<template>
  <div class="animated fadeIn reg">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns
              v-model="fields"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <div style="overflow:auto" class="mt-2">
            <b-table
              id="api-imports-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              v-columns-resizable="{afterResize: columnsWidthChanged}"
            >
              <template v-slot:head()="scope">{{ $t(scope.label) }}</template>

              <template v-slot:cell(eshop_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(source)="data">
                <span v-if="data.value">{{source[data.value]}}</span>
              </template>

              <template v-slot:cell(shop_code)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(ecompany_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/companies/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(eproduct_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/products/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:head(selected)>
                <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                  <input type="checkbox" @click.stop @change="selectAll" v-model="checkAll" />
                  <span></span>
                </label>
              </template>
              <template v-slot:cell(selected)="data">
                <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                  <input type="checkbox" @click.stop :value="data.item.eid" v-model="selected" />
                  <span></span>
                </label>
              </template>

              <template v-slot:cell(stake)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(payment)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(payment_tax)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(winnings)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(unclaimed_winnings)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(expired_winnings)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(expired_winnings_tax)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(paid_out_winnings)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(cancelled_amount)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(cancelled_tax)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(hold)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(bonus_payout)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(bonus_payout_tax)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(ticket_balance_amount)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(ticket_balance_amount)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(payout_tax)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>
              <template v-slot:cell(payout)="data">
                <span>{{ roundThousands(data.value) }}</span>
              </template>

              <template v-slot:cell(timestamp)="data">
                <span>{{ mom_unix(data.value).format(tableDateShort) }}</span>
              </template>
              <template v-slot:cell(date_from)="data">
                <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
              </template>
              <template v-slot:cell(date_to)="data">
                <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                >{{$t('Apply')}}</b-button>
                <span class="pagination-sep" v-if="selected.length"></span>
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'api-imports-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import BulkActionSelect from "@/components/BulkActionSelect";

export default {
  name: "apiImports",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    BulkActionSelect
  },
  data: function() {
    return {
      tableName: "apiImports",

      bulkAction: null,
      bulkActionOptions: [{ text: "Reimport", field: "reimport", value: true }],

      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: []
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter(item => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter(item => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },
        {
          field: "shop_id",
          multiple: true,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map(elem => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map(elem => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map(elem => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                elem => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            //console.log("selectedTenants", selectedTenants);
            //console.log("selectedShopGroups", selectedShopGroups);

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
              //console.log("orig", orig);
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                // filter by selected tenants
                tmp = orig.filter(item => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter(item => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              //console.log("tmp", tmp);

              data.list[index].options = tmp;
            }
          }
        },
        {
          field: "source",
          multiple: true,
          placeholder: "Source",
          translate: false,
          options: [
            { name: "Manual", value: 0 },
            { name: "NSoft Import", value: 1 },
            { name: "Loto Import", value: 2 },
            { name: "Newton Import", value: 3 },
            { name: "WSix Import", value: 3 }
          ],
          selected: []
        },
        {
          field: "timestamp",
          type: "date",
          opens: "right",
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          ranges: {
            "Last hour": [moment().subtract(1, "hour"), moment()],
            "Last 6 hours": [moment().subtract(6, "hours"), moment()],
            "Last 24 hours": [moment().subtract(24, "hours"), moment()],
            Today: [moment().startOf("day"), moment().endOf("day")],
            Yesterday: [
              moment()
                .subtract(1, "days")
                .startOf("day"),
              moment()
                .subtract(1, "days")
                .endOf("day")
            ],
            "This week": [
              moment().startOf("isoWeek"),
              moment().endOf("isoWeek")
            ],
            "Last week": [
              moment()
                .subtract(1, "week")
                .startOf("isoWeek"),
              moment()
                .subtract(1, "week")
                .endOf("isoWeek")
            ],
            "This month": [moment().startOf("month"), moment().endOf("month")],
            "Last month": [
              moment()
                .subtract(1, "month")
                .startOf("month"),
              moment()
                .subtract(1, "month")
                .endOf("month")
            ],
            "This year": [moment().startOf("year"), moment().endOf("year")],
            "Last year": [moment().subtract(1, "year"), moment()]
          }
        }
      ],

      fields: [
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true
        },
        {
          key: "source",
          label: "Source",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "ecompany_id",
          label: "Company",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "shop_code",
          label: "Shop Code",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "eshop_id",
          label: "Shop",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "date_from",
          label: "Date From",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "date_to",
          label: "Date To",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "timestamp",
          label: "Timestamp",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "stake",
          label: "Stake",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "payment",
          label: "Payment",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "payment_tax",
          label: "Payment Tax",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "winnings",
          label: "Winnings",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "unclaimed_winnings",
          label: "Unclaimed Winnings",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "expired_winnings",
          label: "Expired Winnings",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "expired_winnings_tax",
          label: "Expired Winnings Tax",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "paid_out_winnings",
          label: "Paid Out Winnings",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "cancelled_amount",
          label: "Cancelled Amount",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "cancelled_tax",
          label: "Cancelled Tax",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "hold",
          label: "Hold",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "bonus_payout",
          label: "Bonus Payout",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "bonus_payout_tax",
          label: "Bonus Payout Tax",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "ticket_balance_amount",
          label: "Ticket Balance Amount",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "ticket_paid_in_number",
          label: "Ticket Paid In Number",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "ticket_won_number",
          label: "Ticket Won Number",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "ticket_paid_out_number",
          label: "Ticket Paid Out Number",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "ticket_bonus_paid_out_number",
          label: "Ticket Bonus Paid Out Number",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "ticket_cancelled_number",
          label: "Ticket Cancelled Number",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "ticket_expired_winnings_number",
          label: "Ticket Expired Winnings Number",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "payout",
          label: "Payout",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "payout_tax",
          label: "Payout Tax",
          sortable: true,
          ignore: true,
          class: ""
        }
      ],

      source: [
        "Manual",
        "NSoft Import",
        "Loto Import",
        "Newton Import",
        "WSix Import"
      ],
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      selected: [],
      copy: null,
      addLabel: "",
      selected_products: [],

      balancePreviousDay: 0,
      subtotalIn: 0,
      subtotalOut: 0,
      total: 0
    };
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["apiImports/endpoint"];

      return `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach(item => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = ["eshop_id"];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    }
  },
  methods: {
    selectAll() {
      this.selected = [];
      this.copy.forEach(item => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected
      };

      this.$store.dispatch("apiImports/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.refresh();
      });
    },
    refresh() {
      this.$root.$emit("bv::refresh::table", "api-imports-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = this.buildPagination();
      this.selected_products = this.filterOptions[4].selected;

      const companyByID = this.$store.getters["cache/companyByID"];
      const shopByID = this.$store.getters["cache/shopByID"];
      const productByID = this.$store.getters["cache/productByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "companies").catch(e => e),
        this.$store.dispatch("cache/fetch", "shops").catch(e => e),
        this.$store.dispatch("cache/fetch", "products").catch(e => e)
      ]).finally(() => {
        this.$store
          .dispatch("apiImports/fetch", paginationData)
          .then(resp => {
            this.totalRows = resp.data.total;
            resp.data.rows.forEach((item, index) => {
              if (item.eshop_id) {
                const data = shopByID(item.eshop_id);
                if (data) {
                  item.eshop_id = {
                    to: item.eshop_id,
                    name: data.name
                  };
                  item.shop_code = {
                    to: item.eshop_id,
                    name: data.code
                  };
                } else {
                  item.eshop_id = {
                    to: null,
                    name: item.eshop_id
                  };
                  item.shop_code = {
                    to: null,
                    name: item.eshop_id
                  };
                }
              }
              if (item.ecompany_id) {
                const data = companyByID(item.ecompany_id);
                if (data) {
                  item.ecompany_id = {
                    to: item.ecompany_id,
                    name: data.name
                  };
                } else {
                  item.ecompany_id = {
                    to: null,
                    name: item.ecompany_id
                  };
                }
              }
              if (item.eproduct_id) {
                const data = productByID(item.eproduct_id);
                if (data) {
                  item.eproduct_id = {
                    to: item.eproduct_id,
                    name: data.name
                  };
                } else {
                  item.eproduct_id = {
                    to: null,
                    name: item.eproduct_id
                  };
                }
              }
            });
            callback(resp.data.rows);
          })
          .catch(err => {
            this.$bvToast.toast(
              this.$t(
                err.details && err.details.length ? err.details[0] : err.message
              ),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });
      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach(el => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = moment().startOf("day");
            paginationData.dateEnd = moment().endOf("day");
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return paginationData;
    },
    rowClicked(item, index, event) {
      this.$router.push("/api-imports/" + item.eid);
    },
    redirect(item) {}
  }
};
</script>

<style lang="scss" scoped>
.reg {
  & /deep/ #cash-register-table tfoot th {
    border: 0 !important;
  }
}
</style>
